// 逻辑题目显示 与 隐藏
export const setQuestionLogicBlock = ( questions, isCancel = false ) => {
  console.log(111, "----------")
  // 所有子题目
  const questionBlocks = questions.filter(q=>{
      return q.logic.blocks.list.length
  })
  questionBlocks.forEach((question) =>{
      // 子题中关联的逻辑
      let blocks = question.logic.blocks
      let ruleCount = 0 // 当前子题已符合个数
      blocks.list.forEach((block) =>{
          // 关联中的每道题的值
          // 显示的问题去计算逻辑
          let currentQuestion = questions.filter(q=>{
              return q.tenantId === block.questionId
          })[0]
          if( currentQuestion.v_answer && currentQuestion.v_visible ){
              let currentValue = currentQuestion.v_answer.currentValue || []

            //   ******
              if(typeof currentValue  !== 'string' && currentValue[0] != undefined &&  typeof currentValue[0] !== 'string'){
                currentQuestion.v_answer.currentValue = currentValue[0]
                currentValue = currentValue[0]
              }
            // *******

              // 逻辑设置单选改成任一选中，这里统一数组
              currentValue = typeof currentValue  === 'string' ? [currentValue] : currentValue
            //   // 单选 选中则显示该问题
            //   if ( block.typeOption === 'checked' ){
            //       if( block.radioOptionId === currentValue.toString() ){
            //           ruleCount += 1
            //       }else{
            //           ruleCount += 0
            //       }
            //   }

              // // 单选 全部选中 则显示该问题
              // if ( block.typeOption === 'unChecked' ){
              //     if( block.radioOptionId !== currentValue.toString() ){
              //         ruleCount += 1
              //     }else{
              //         ruleCount += 0
              //     }
              // }

              // 多选 全部选中 则显示该问题
              if ( block.typeOption === 'allChecked' ){
                  let status = block.checkboxOptionId.length <= currentValue.length // 是否全部选中状态
                  if( status ){
                      block.checkboxOptionId.forEach(id=>{
                          if( !currentValue.includes( id ) ){
                              status = false
                          }
                      })
                  }
                  ruleCount += Number(status)
              }

              // 多选 任一选中 则显示该问题
              if ( block.typeOption === 'anyChecked' ){
                  let status =  !!~block.checkboxOptionId.findIndex((id)=>{
                      return currentValue.includes( id )
                  }) 
                  // 是否任一选中状态
                //   block.checkboxOptionId.forEach(id=>{
                //       if( currentValue.includes( id ) ){
                //           status = true
                //       }
                //   })
                //   console.log("111currentValue: ", block.checkboxOptionId, currentValue, status)
                  ruleCount += Number(status)
              }
          }
      })
      
      let v_visible = false
      // 任一匹配,rulecount 大于1 即可
      if ( blocks.typeBlock === 'any' ){
        //   isCancel && (ruleCount = 0)
          v_visible = ruleCount > 0 ? true : false
      }
      // 全部匹配
      if ( blocks.typeBlock === 'all' ){
        //   isCancel && (ruleCount = 0)
          v_visible = ruleCount === blocks.list.length ? true : false
      }
      
      //   console.log(111, question.title, isCancel, ruleCount, question.v_visible, v_visible)
      // 查看是否触发改变
      if( question.v_visible !== v_visible ){
          // 如果隐藏，需要暂存答案
          question.v_visible = v_visible
          // 如果是父题，又是子题
          if( question.v_isParent ){
              setQuestionLogicBlock( questions, isCancel )
          }
      }
  })
  return questions
}